import { render, staticRenderFns } from "./AccountFacebook.vue?vue&type=template&id=ed4a5b68&scoped=true"
import script from "./AccountFacebook.vue?vue&type=script&lang=js"
export * from "./AccountFacebook.vue?vue&type=script&lang=js"
import style0 from "./AccountFacebook.vue?vue&type=style&index=0&id=ed4a5b68&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4a5b68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed4a5b68')) {
      api.createRecord('ed4a5b68', component.options)
    } else {
      api.reload('ed4a5b68', component.options)
    }
    module.hot.accept("./AccountFacebook.vue?vue&type=template&id=ed4a5b68&scoped=true", function () {
      api.rerender('ed4a5b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/AccountFacebook.vue"
export default component.exports